import { istanbulDayString, istanbulHourOf } from '@aquabox/shared';
import type { Trip, TripStatus } from '../api/types';

/** Sunucudaki `TRIP_OPEN_STATUSES` ile aynı küme (trip-status.ts). */
export const OPEN_TRIP_STATUSES: readonly TripStatus[] = [
  'OPENED',
  'LOADING',
  'ON_ROUTE',
  'CLOSING',
];

/** İptal edilebilen açık durumlar; ON_ROUTE/CLOSING'i şoför kapatır (kural 11). */
export const PANEL_VOIDABLE_OPEN: readonly TripStatus[] = ['OPENED', 'LOADING'];

/** Sunucudaki `STALE_YESTERDAY_CUTOFF_HOUR` (trips/trip-day.ts) ile aynı sabit. */
const CUTOFF_HOUR = 5;

function dayBefore(day: string): string {
  const d = new Date(`${day}T00:00:00.000Z`);
  d.setUTCDate(d.getUTCDate() - 1);
  return d.toISOString().slice(0, 10);
}

/** `tenant.settings.eveningLoadFromHour` varsayılanı; panel ayarı okumaz, karar sunucudadır. */
const EVENING_HOUR = 15;

/**
 * Bayat açık sefer rozeti; sunucudaki `isStaleTrip` (trips/trip-day.ts) kuralını yansıtır, sunucu
 * karar vericidir (hareketsizlik ayağı panelde bilinmez, orada rozet çıkmaz).
 *  - OPENED/LOADING: tripDate 2+ gün önce → bayat; dün ise yalnız seferin açılış saati (İstanbul)
 *    akşam dolumu eşiğinden önceyse (terk edilmiş sabah seferi) bayat.
 *  - ON_ROUTE/CLOSING: etkin gün = max(tripDate, departedAt günü); 2+ gün önce → bayat; dün ve
 *    İstanbul saati >= 05:00 → bayat.
 * `today` = `istanbulDayString(now)`, `hour` = İstanbul saati (0-23).
 */
export function isStaleOpenTrip(
  trip: Pick<Trip, 'status' | 'tripDate' | 'openedAt' | 'departedAt'>,
  today: string,
  hour: number,
): boolean {
  if (!OPEN_TRIP_STATUSES.includes(trip.status)) return false;
  const yesterday = dayBefore(today);
  let day = trip.tripDate.slice(0, 10);
  if (trip.status === 'OPENED' || trip.status === 'LOADING') {
    if (day >= today) return false;
    if (day < yesterday) return true;
    return istanbulHourOf(new Date(trip.openedAt)) < EVENING_HOUR;
  }
  // tripDate 2+ gün önceyse departedAt ne olursa olsun bayat (sunucu kuralı).
  if (day < yesterday) return true;
  if (trip.departedAt) {
    const departedDay = istanbulDayString(new Date(trip.departedAt));
    if (departedDay > day) day = departedDay;
  }
  if (day >= today) return false;
  if (day < yesterday) return true;
  return hour >= CUTOFF_HOUR;
}
